/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
==========================================================================================*/

import indexFourn from "../../http/requests/fournisseur/index.js"


export default {
  fetchArticles({ commit }) {    
    indexFourn.GetMyArticles("FR40A004")                             //wini page html normal
      .then(response => {
         
        console.log(response)
        commit('UPDATE_ARTICLE', response.data.value)
      }) .catch(error => {
        console.log("error in loading products :"+ error)
    });
  },
  UPDATE_PERIODE({commit},payload){
commit('UPDATE_PERIODE',payload)
  },
  UPDATE_PERIODE_YEAR({commit},payload){
    commit('UPDATE_PERIODE_YEAR',payload) 
  }
  
}

